var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Prop, Watch } from 'vue-facing-decorator';
import { QuillEditor } from '@vueup/vue-quill';
let RichTextareaVue = class RichTextareaVue extends Vue {
    constructor() {
        super(...arguments);
        this.content = '';
        this.selection = null;
        this.editorOptions = {
            modules: {
                toolbar: [
                    ['bold', 'italic', 'underline', 'strike'], // toggled buttons
                    [{ 'header': 1 }, { 'header': 2 }], // custom button values
                    [{ 'color': [] }, { 'background': [] }], // dropdown with defaults
                    ['clean'], // remove formatting button
                    ['link', 'image'] // link and image
                ],
                clipboard: {
                    matchVisual: false // Prevents unwanted whitespace
                }
            },
            placeholder: '',
        };
    }
    mounted() {
        this.content = this.modelValue;
    }
    onModelValueChange(newValue) {
        if (this.content !== newValue) {
            this.content = newValue;
        }
    }
    onContentChange(newValue) {
        if (this.maxlength && this.getPlainText().length > this.maxlength) {
            // Restore previous content if exceeds maxlength
            this.content = this.modelValue;
            return;
        }
        this.$emit('update:modelValue', newValue);
    }
    getPlainText() {
        var _a;
        const quill = (_a = this.$refs.quillEditor) === null || _a === void 0 ? void 0 : _a.getQuill();
        return (quill === null || quill === void 0 ? void 0 : quill.getText()) || '';
    }
    handleTextChange() {
        // Additional text change handling if needed
    }
    handleSelectionChange(range) {
        this.selection = range;
    }
    getSelection() {
        var _a;
        const quill = (_a = this.$refs.quillEditor) === null || _a === void 0 ? void 0 : _a.getQuill();
        if (!quill)
            return null;
        const range = quill.getSelection();
        if (!range)
            return null;
        return {
            start: range.index,
            end: range.index + range.length,
            text: quill.getText(range.index, range.length),
            formattedStart: range.index,
            formattedEnd: range.index + range.length
        };
    }
    insertLink(url, text) {
        var _a;
        const quill = (_a = this.$refs.quillEditor) === null || _a === void 0 ? void 0 : _a.getQuill();
        if (!quill)
            return;
        const range = quill.getSelection(true);
        if (range) {
            // Delete selected text if any
            if (range.length > 0) {
                quill.deleteText(range.index, range.length);
            }
            // Insert link
            quill.insertText(range.index, text, 'link', url);
            // Move cursor to end of insertion
            quill.setSelection(range.index + text.length, 0);
        }
    }
};
__decorate([
    Prop({ type: String, default: '' }),
    __metadata("design:type", String)
], RichTextareaVue.prototype, "modelValue", void 0);
__decorate([
    Prop({ type: Number }),
    __metadata("design:type", Number)
], RichTextareaVue.prototype, "maxlength", void 0);
__decorate([
    Watch('modelValue'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RichTextareaVue.prototype, "onModelValueChange", null);
__decorate([
    Watch('content'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RichTextareaVue.prototype, "onContentChange", null);
RichTextareaVue = __decorate([
    Component({
        name: 'RichTextareaVue',
        components: {
            QuillEditor
        },
        emits: ['update:modelValue', 'blur']
    })
], RichTextareaVue);
export default RichTextareaVue;
